import { Button, Popconfirm, Upload } from 'antd';
import { ImageOff, UploadCloud } from 'lucide-react';
import type { LogoVariant } from './company-settings.api';

const ACCEPT = 'image/svg+xml,image/png,image/webp';

interface CompanyLogoUploadProps {
  variant: LogoVariant;
  label: string;
  hint: string;
  logoUrl: string | null;
  saving: boolean;
  onUpload: (file: File) => void;
  onRemove: () => void;
}

/** One logo slot: a preview box, replace and remove. SVG, PNG or WebP up to 512 KB — the server has the final say. */
export function CompanyLogoUpload({ variant, label, hint, logoUrl, saving, onUpload, onRemove }: CompanyLogoUploadProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="grid h-16 w-32 shrink-0 place-items-center rounded-lg border border-line bg-page">
        {logoUrl ? <img src={logoUrl} alt={label} className="h-full max-h-14 w-full max-w-28 object-contain" /> : <ImageOff className="size-5 text-muted" />}
      </div>
      <div>
        <div className="text-sm font-medium text-fg">{label}</div>
        <div className="mb-2 text-xs text-muted">{hint}</div>
        <div className="flex gap-2">
          <Upload
            key={variant}
            accept={ACCEPT}
            showUploadList={false}
            disabled={saving}
            beforeUpload={(file) => {
              onUpload(file);
              return false;
            }}
          >
            <Button size="small" icon={<UploadCloud className="size-3.5" />} loading={saving}>
              {logoUrl ? 'Replace' : 'Upload'}
            </Button>
          </Upload>
          {logoUrl && (
            <Popconfirm title={`Remove the ${label.toLowerCase()}?`} onConfirm={onRemove}>
              <Button size="small" danger disabled={saving}>
                Remove
              </Button>
            </Popconfirm>
          )}
        </div>
      </div>
    </div>
  );
}
